// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Gd-z","landingPageVideo":"Hd-z","play":"Id-z","iframeVideo":"Jd-z","playHidden":"Kd-z","fullwidth":"Ld-z"};